'use client';
import { useState, useEffect, useRef } from 'react';
import { AxiosInstance } from '../utils';

import Slider from "react-slick";
import Spinner from '../Spinner';

function SponsorSection({ eventInfo }: any) {
    const [loading, setLoading] = useState(true);
    const [tabses, setTabses] = useState([] as any);
    const [tabsesbycat, setTabsesbycat] = useState({} as any);
    let temptabs: any[] = [];
    let temptabsbycat: any = {};
    let temptabsbycatpri: any = {};
    var settings = {
        slidesToShow: 6,
        slck: true,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        arrows: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }]
    };
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            temptabsbycat = {};
            temptabsbycatpri = {};
            try {
                const { data: response } = await AxiosInstance.get('/api/getsponsors?eventcode=' + eventInfo.eventcode);
                if (response.result != "Success" || response.data?.length == 0) {
                    // Set empty tabs to trigger the "no sponsors" message
                    setTabses([]);
                    setLoading(false);
                    return;
                }
                for (let i = 0; i < response.data.length; i++) {

                    

                        //
                        let tmpObj = response.data[i];

                        if (!temptabsbycat[tmpObj.category])
                        {
                            temptabsbycat[tmpObj.category] = [];
                        }

                        if (!temptabsbycatpri[tmpObj.priority])
                        {
                            temptabsbycatpri[tmpObj.priority] = tmpObj.category;
                        }

                       var ttap = temptabsbycat[tmpObj.category];

                       ttap.push(<>
                           
                            
                                <li><a  target="_blank" href={tmpObj.website} title={tmpObj.name}><img style={{maxWidth:"250px", maxHeight:"150px"}}  src={tmpObj.imageurl} alt={tmpObj.name} /></a><h3 className="sponsorname">{tmpObj.name}</h3></li>
                          
                        </>);

                    

                }
            } catch (error) {
                console.error(error);
            }
            Object.keys(temptabsbycatpri).forEach(key => {
                temptabs.push(<>
                <div className="row">
            <div className="col-lg-12">
                   <h3 className="sponsorcategory">{ temptabsbycatpri[key] }</h3>
                   <ul className="sponsor-social-line list-inline">
                        {temptabsbycat[temptabsbycatpri[key]]}
</ul>
                        </div>
                        </div>
                </>);
            });
            setTabses(temptabs);
            setLoading(false);
        }
        fetchData();


        return () => {
        }

    }, []);
    return (
        <section className="sec-padding" id="sponsor" data-scroll-index="3">

            <div className="container">
                <div className="sec-title">
                    <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-money fa-stack-1x"></i></span></span>
                    <h3 className="wow fadeInRight" data-wow-duration="500ms">Sponsors <small>/ Valued Partnerships</small></h3>
                </div> {/* <!--sec-title end--> */}


                <div className="partner-sec">
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                            <Spinner size="medium" />
                        </div>
                    ) : tabses.length === 0 ? (
                        <div className="row">
                            <div className="col">
                                <div className="text-center py-5">
                                    <h3 className="text-muted">Sponsors are being registered!</h3>
                                    <p className="text-muted">Stay tuned for exciting announcements about our valued partners and sponsors.</p>
                                </div>
                            </div>
                        </div>
                    ) : (
                        tabses
                    )}
                    <div className="spons-dv text-center">
                        <a href="#contact" title="" data-scroll-nav="9" className="btn-default"><i className="fa fa-thumbs-up"></i> become a sponsor</a>
                    </div> {/* <!--spons-dv end--> */}
                </div> {/* <!--partner-sec end--> */}
            </div>
        </section>
    )
};
export { SponsorSection };